export const MES = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];

const TINTS = ['#1F5140', '#C4881F', '#2B4A8B', '#A8382A', '#7A5A2E'];

/** A stable colour per handle, so a friend's avatar keeps its tint. */
export function tintFor(handle: string): string {
  let sum = 0;
  for (const ch of handle) sum = (sum + ch.charCodeAt(0)) % 997;
  return TINTS[sum % TINTS.length]!;
}

export function initialOf(handle: string): string {
  return (handle.replace(/^@/, '')[0] ?? '?').toUpperCase();
}

// Tiny flags for the album's close-up; Ecuador's matches the design.
export const FLAGS: Record<string, string> = {
  ecuador: 'linear-gradient(#FFD100 0 33.3%, #0F47AF 33.3% 66.6%, #EF3340 66.6%)',
  colombia: 'linear-gradient(#FCD116 0 50%, #003893 50% 75%, #CE1126 75%)',
  francia: 'linear-gradient(90deg, #0055A4 0 33.3%, #FFFFFF 33.3% 66.6%, #EF4135 66.6%)',
  'reino unido':
    'linear-gradient(90deg, transparent 42%, #C8102E 42% 58%, transparent 58%), linear-gradient(transparent 36%, #C8102E 36% 64%, transparent 64%), #012169',
};

/** Ecuador and Colombia price stamps in centavos; elsewhere the denomination stands alone. */
export function denomination(country: string, denom: string): string {
  return country === 'ecuador' || country === 'colombia' ? `${denom} ctvs` : denom;
}
